<template>
  <div>
    <header-applis titre="Personnaliser l'offre à votre profil" sous-titre="S’organiser dans son activité professionnelle" index-progression-courante="3"
                   index-progression-secondaire="6"/>
    <choix-competence-repeater :competences="competences" :callback="sauvegarder"/>
    <skip-competences ecrant-suivant="utilisercodessociaux"/>
    <footer-applis ecran-precedent="gererinformations" ecran-suivant="activitesquotidiennes" label-suivant="Je ne souhaite pas répondre aux questions"/>
  </div>
</template>

<script>
import HeaderApplis from '../../components/HeaderApplis';
import FooterApplis from '../../components/FooterApplis';
import ChoixCompetenceRepeater from '../../components/ChoixCompetenceRepeater';
import SkipCompetences from '../../components/SkipCompetences';

export default {
  name: 'organiseractivite',
  components: {
    SkipCompetences,
    ChoixCompetenceRepeater,
    HeaderApplis,
    FooterApplis
  },
  data() {
    return {
      competences: [{
        niveau: 1,
        valeur: 'J\'identifie et mets en œuvre les tâches à organiser dans une activité donnée'
      }, {
        niveau: 2,
        valeur: 'J\'organise des activités récurrentes selon les contraintes et les cadres associés'
      }, {
        niveau: 3,
        valeur: 'J\'établis des priorités et planifie en tenant compte des consignes et des exigences d’une organisation'
      }, {
        niveau: 4,
        valeur: 'J\'anticipe et prévois des modes d’organisation selon d’éventuels imprévus'
      }]
    }
  },
  methods: {
    competencesTransversales() {
      return this.$store.getters.getCompetencesTansversales;
    },
    sauvegarder(competence) {
      let informations = {};
      Object.assign(informations, this.competencesTransversales());
      informations.organiseractivite = competence;
      this.$store.commit('setCompetencesTransversales', informations);
      this.$router.push('utilisercodessociaux');
    }
  }
}
</script>
